module.exports = __webpack_public_path__ + "media/assets/DefaultAlert-ead772b7e6dc89f2fe6c6239731d1b93.svg";